<template>
  <div class="recently-card">
    <div :class="['status' ,contract.status]">{{contract.status | ContractStatusFormat}}</div>
    <div class="msg">
      <img :src="logo" />
      <div class="info">
        <div class="name">{{contract.contractName |HandleNameLen(7) }}</div>
        <div class="sign-man">
          发起人
          <span>{{contract.issueUserName}}</span><br/>
        </div>
        <div class="sign-man">
          签署人
          <span>{{contract.presentUserName}}</span>
        </div>
        <div class="create-time">{{ new Date(Date.parse(contract.createDate.replace(/-/g,  "/"))) | timeFormat("yyyy-mm-dd") }}</div>
      </div>
    </div>
    <div class="contract-btn">
      <el-button class="detail btn"  @click="router_go({id:contract,path:'/document/'+contract.status+'/details'})">详情</el-button>
      <el-button v-if="contract.status == 'wait_for_me'" class="wait-for-me btn" @click="sign(contract)">立即签署</el-button>
      <el-button v-if="contract.status == 'drafts'" class="wait-for-me btn" @click="SignImmediately(contract)">发起签署</el-button>
      <el-button v-if="contract.status == 'completed'" class="wait-for-me btn" @click="add_xiang(contract)">立即下载</el-button>
<!--      <el-button v-if="contract.status == 'drafts'" class="wait-for-me btn" @click="del(contract)">删除</el-button>-->
    </div>
<!--    case "drafts": return "草稿箱";
		case "wait_for_me": return "待我签";
		case "wait_for_other": return "待他人签";
		case "user_refuse": return "用户拒签";
		case "overdue": return "过期";
		case "recall": return "撤回";
		case "completed": return "已完成";
		default: return "未知状态";-->
  </div>
</template>

<script>
export default {
  props: {
    contract: {
      type: Object,
      defalut: function() {
        return {
          status: "wait_for_me",
          mesla:{},
        };
      }
    }
  },
  data() {
    return {
      user:this.$SIF.getLocalStorage("userInfo"),
    };
  },
  created() {
    this.createLogoUri();
    this.getMeals()
  },
  methods: {
    // 获取是否有套餐
    getMeals() {
      this.$SIF.httpPost({
        url: this.$SIF._serve.meal + "/centreBalanceController/getUserId",
        succFun: res => {
          this.mesla = res.data
        },
        failFun: res => {
          this.$message({
            message: res.msg,
            type: 'warning'
          });
        }
      });
    },
    sign(i){
      if(this.user.authenStatus!=1){
        this.$confirm('账号还没有认证,请先去认证.', '提示', {
          confirmButtonText: '去认证',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({name: this.user.userType==1?'enterpriseAuthe':'personalAuthentication'})
        });
        return
      }
      this.$router.push(
              { path: '/signature_of_documents',
                query: { id:i.id,contractId:i.contractId,serial:3,contractJoinUserId:i.contractJoinUserId}
              });
    },
    SignImmediately(i){
      if(this.user.authenStatus!=1){
        this.$confirm('账号还没有认证,请先去认证.', '提示', {
          confirmButtonText: '去认证',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({name: this.user.userType==1?'enterpriseAuthe':'personalAuthentication'})
        });
        return
      }
      if(!this.mesla){
        this.$confirm('套餐余额不足，请重新购买套餐', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({name: 'buyMeal'})
        });
        return;
      }
      this.$router.push({ name: 'local_file', params: { test: i.contractName,id:i.contractId,type:2,data:i,pdfFileSaveId:i.pdfFileSaveId} });
    },
    del(i){
      this.$confirm('确定要删除该合同吗?删除之后无法恢复.请谨慎操作', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$SIF.httpPost({
          url: this.$SIF._serve.manage + "/contract/delete",
          data: {
            contractId:i.contractId
          },
          succFun: res => {
            if(res.code == 10000){
              this.$message({
                message: '删除成功',
                type: 'success'
              });
            }else {
              this.$message({
                message: res.msg,
                type: "warning"
              });
            }

          }
        });
      });
    },
    createLogoUri: function() {
		 this.logo = require("@/assets/img/contract/recently_"+this.contract.status+".png");
    },
    router_go({ id, path }) {
      this.$router.push({ path: path, query: { id: id.pdfFileSaveId ,type:'1',ids: id.id} });
    },
    add_xiang(i){
      var arr = i.pdfFileSaveId;
      this.$SIF.downloadFile({
        params: { id: arr },
        succFun: res => {
          // var liet =res.data.url.split("/filePath2")
          // this.mySeal_file =  this.$SIF.get_file + liet[1];
          this.mySeal_file =  res.data.url;
          if(window.navigator.msSaveBlob){
            try{
              fetch(this.mySeal_file).then(res => res.blob().then(blob => {
                window.navigator.msSaveBlob(blob, i.contractName +'.pdf');
              }));
            }
            catch(e){
              console.log(e)
            }
          }else {
            fetch(this.mySeal_file).then(res => res.blob().then(blob => {
              var a = document.createElement('a');
              var url = window.URL.createObjectURL(blob);
              var filename = i.contractName +'.pdf';
              a.href = url;
              a.download = filename;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);
              document.body.removeChild(a)
            }));
          }
        }
      });
    },
  }
};
</script>

<style>
.recently-card {
  width: 100%;
  height: 152px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 1px solid rgba(234, 234, 234, 1);
}
.recently-card:hover{
  /*background: rgba(27, 133, 85, 0.15);*/
  border:1px solid rgba(49,202,132,1);
}
.recently-card .status {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  /* color: rgba(255, 175, 5, 1); */
  line-height: 20px;
  margin-top: 10px;
  margin-left: 21px;
}
.recently-card .msg {
  display: flex;
}
/*
	 * 卡片LOGO
	 */
.recently-card img {
  height: 41px;
  width: 41px;
  margin-left: 22px;
  margin-top: 11px;
  margin-right: 16px;
}
/*
	 * 合同详细信息
	 */
.recently-card .info {
  height: 90px;
  width: 65%;
  display: inline-block;
  position: relative;
  top: 5px;
}
.recently-card .info .name {
  width: 120px;
  font-size: 14px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #616161;
  line-height: 21px;
}
.recently-card .info .sign-man {
  font-size: 12px;
  font-family: SourceHanSansCN-Light, SourceHanSansCN;
  font-weight: 300;
  color: rgba(151, 151, 151, 1);
  line-height: 18px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.recently-card .info .sign-man span {
  margin: 0 5px;
  color: #31ca84;
}
/*
	 * 创建时间
	 */
.recently-card .create-time {
  font-size: 12px;
  font-family: SourceHanSansCN-Light, SourceHanSansCN;
  font-weight: 300;
  color: rgba(149, 149, 149, 1);
  line-height: 20px;
}
.recently-card .contract-btn {
  position: relative;
  bottom: 5px;
  height: 30px;
  width: 100%;
  text-align: center;
}
.contract-btn /deep/ .el-button {
 line-height: 0 !important;
  padding: 12px 0px !important;
}

.recently-card .contract-btn .detail {
  margin-right: 20px;
}
.recently-card .contract-btn .btn {
  display: inline-block;
  width: 68px;
  height: 25px;
  border-radius: 13px;
  border: 2px solid rgba(178, 231, 207, 1);
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(49, 202, 132, 1);
  line-height: 21px;
  padding: 0;
}
.recently-card .wait_for_me{
color: #FFBE60;
}
.recently-card .wait_for_other{
color: #38B0FB;
}
.recently-card .user_refuse{
color: #FF6000;
}
.recently-card .overdue{
color: #CBCBCB;
}
.recently-card .completed{
color: #30D088;
}
.recently-card .drafts{
color:#7177F3;
;
}
/* drafts	草稿箱
wait_for_me	待我签
wait_for_other	待他人签
user_refuse	用户拒签
overdue	过期
recall	撤回
completed	已完成 */
</style>